import { useNotify } from '../utils/helpers/AppNotificationProvider.jsx';
import extractApiErrorMessage from '../utils/helpers/extractApiErrorMessage.jsx';

export function useToastMessages() {
  const notify = useNotify();

  const success = (message, key = null, duration = 7) =>
    notify.success({ message, key, duration });
  const error = (message, key = null, duration = 7) =>
    notify.error({ message, key, duration });

  return {
    errorOccurred: () => error('Nastala chyba'),
    saveSuccess: () => success('Úspešne uložené'),
    saveFailed: (err) => error(extractApiErrorMessage(err)),
    apiErrorMessage: (err) => error(extractApiErrorMessage(err)),
    deleteSuccess: () => success('Položka úspešne vymazaná'),
    deleteFailed: (err) => error(extractApiErrorMessage(err)),
    serverError: () => error('Nastala chyba na serveri.'),
    dismissToast: (key) => notify.dismiss(key),

    successMessage: ({
      message,
      description = null,
      key = null,
      duration = 7,
    } = {}) => notify.success({ message, description, key, duration }),

    errorMessage: ({
      message,
      description = null,
      key = null,
      duration = 7,
    } = {}) => notify.error({ message, description, key, duration }),

    warningMessage: ({
      message,
      description = null,
      key = null,
      duration = 7,
    } = {}) => notify.warning({ message, description, key, duration }),

    infoMessage: ({
      message,
      description = null,
      key = null,
      duration = 7,
    } = {}) => notify.info({ message, description, key, duration }),
  };
}
